import ClassDatesBlocksList from './ClassDatesBlocksList';

export default function ClassDatesCalendar({ dates }) {
  return (
    <div className="flex flex-col space-y-4 prose lg:prose-lg">
      <h3 className="text-lg lg:text-xl font-semibold">Calendario de clases</h3>
      <div className="flex flex-wrap w-full gap-y-4">
        <ClassDatesBlocksList dates={dates} />
      </div>
    </div>
  );
}
